<template>
  <div>
    <nav>
      <ul class="pager">
        <li class="previous">
          <router-link :to="{name: 'client_reports', client_id: $route.params.client_id}">
            <span aria-hidden="true">&larr;</span> Reports
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <h2>
          Drug Chart Report
        </h2>


        <div class="panel-body">
          <form v-on:submit.prevent="onSubmit">
            <input type="submit" class="btn btn-primary" value="Generate"/>
            <template v-if="hasData">
              | <a :href="exportUrl" target="_blank" class="btn btn-success">Download as PDF</a>
            </template>
            <div v-if="searching">
              <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            </div>
          </form>
        </div>
      </div>
    </div>

    <br>

    <div class="panel-body" v-if="hasData">
      <div class="row">
        <div class="col-md-4 text-left">
          <p class="title">{{ headers["title"] }}</p>
          <p>Season: {{ headers["season"] }} </p>
          <p>{{ headers["comp_address"] }}</p>
          <p>{{ headers["comp_contact"] }}</p>
          <p>Key Vet: {{ headers["keyvet"] }}</p>
          <p>Email: {{ headers["keyvet_email"] }}</p>
        </div>

        <div class="col-md-4">
        </div>

        <div class="col-md-4 text-right">
          <p>{{ headers["client"] }}</p>
          <p>{{ headers["company"] }}</p>
          <p>{{ headers["address"] }}</p>
          <p>Consultation Date: {{ headers["consult_date"] }}</p>
          <p>Date of expiry of Authorisation: {{ headers["expiration_date"] }}</p>
        </div>
      </div>
      <br>

      <div class="row">
        <table class="table">
          <thead>
            <tr>
              <th>Drug Name</th>
              <th>Used For</th>
              <th>Stock Classes</th>
              <th>Dose Rate/Interval</th>
              <th>Route</th>
              <th>Meat WHP (from last treatment)</th>
              <th>Comments</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(groupDrugs, groupName, groupIndex) in groups">
              <tr class="group-name" :key="groupIndex+'_first_table_row'">
                <td colspan="7">{{ groupName }} </td>
              </tr>
              <tr v-for="(drug, drugIndex) in groupDrugs" :key="groupIndex+groupName+drugIndex">
                <td>{{ drug["drugname"] }}</td>
                <td>{{ drug["usage"] }}</td>
                <td>{{ drug["stockclass"] }}</td>
                <td>{{ drug["doserate"] }}</td>
                <td>{{ drug["route"] }}</td>
                <td>{{ drug["whpmeat"] }}</td>
                <td>{{ drug["comments"] }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { reportService, BACKEND_URL } from '@/_services'

export default {
  name: 'DrugChartReportPage',
  data () {
    return {
      searching: false,
      headers: {},
      groups: {},
    }
  },
  methods: {
    ...mapActions('alert', ['error']),
    onSubmit: function(){
      this.searching = true

      reportService.getDrugChartReportData(
        this.clientId
      ).then((data) => {
        this.headers = data.headers || {}
        this.groups = data.groups
        this.searching = false
      }).catch((error) => {
        this.error({message: error.response.data.msg})
        this.searching = false
      })
    },
    resetData: function(){
      this.headers = {}
      this.groups = {}
      this.searching = false
    },
  },
  computed:
  {
    ...mapState('client', ['currentClient']),
    clientId: function () {
      return this.$route.params.client_id
    },
    hasData: function () {
      return Object.keys(this.headers).length > 0
    },
    exportUrl: function () {
      return `${BACKEND_URL}/api/reports/drug_chart/export_pdf?client_id=${this.clientId}`
    },
  }
};
</script>
<style scoped>
.group-name {
  background-color: rgb(54, 173, 122);
  font-size: 1.15em;
  font-weight: bold;
  text-align: left;
}
</style>
